// Motion experiment, loaded by snippets/stak-motion.liquid only when the hero turns it on.
// Each layer of the hero logo is drawn left to right, base first and the black face last, like a printer laying down a part.
(function () {
  var stage = document.querySelector('[data-stk-print]');
  if (!stage || !window.gsap) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var layers = stage.querySelectorAll('.stk-hero__layer');
  var front = stage.querySelector('.stk-hero__front');
  var parts = Array.prototype.slice.call(layers).concat(front ? [front] : []);
  stage.classList.add('is-live');
  if (reduce || window.Shopify && Shopify.designMode) return;

  gsap.fromTo(parts,
    { clipPath: 'inset(0% 100% 0% 0%)' },
    { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.45, ease: 'power2.inOut', stagger: 0.07, delay: 0.15, clearProps: 'clipPath' });

  if (!window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  var hero = stage.closest('.stk-hero') || stage;
  // At 990px and up Horizon scrolls .page-wrapper instead of the window.
  gsap.matchMedia().add({ desk: '(min-width: 990px)', mob: '(max-width: 989px)' }, function (ctx) {
    var desk = ctx.conditions.desk;
    // As the hero scrolls away the deeper layers slide further down, so the stack opens up like an exploded view.
    var trigger = { trigger: hero, scroller: desk ? document.querySelector('.page-wrapper') : window, start: 0, end: 'bottom top', scrub: true };
    gsap.fromTo(layers, { '--peel': 0 }, {
      '--peel': function (i, el) { return Number(el.style.getPropertyValue('--i')) * (desk ? 5 : 3); },
      ease: 'none', scrollTrigger: trigger
    });
    if (front) gsap.fromTo(front, { '--peel': 0 }, { '--peel': desk ? -18 : -10, ease: 'none', scrollTrigger: trigger });
  });
})();
